import { Component, Prop, Emit, Mixins } from "vue-property-decorator";
import SBButton from '@/components/SBButton';

@Component({
})
export default class SBButtonGeneral extends Mixins(SBButton) {

}
